import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { BrandSymbol } from '../components/brand/BrandSymbol';
import { Button } from '../components/ui/Button';
export function NotFound() {
  usePageMeta('Page not found', 'The page you are looking for could not be found.');
  return <section className="flex min-h-[70vh] items-center bg-midnight text-white" data-id="element-1023" data-mp="155h6sxlhhjih">
      <div className="container-page py-24 text-center" data-id="element-1024" data-mp="1a425utp01x5c">
        <BrandSymbol size={64} className="mx-auto" data-id="element-1025" data-mp="1a3j0ecgjd187" />
        <h1 className="mt-8 font-display text-5xl font-semibold md:text-6xl" data-id="element-1026" data-mp="1f2vnmybbkabb">This page could not be found.</h1>
        <p className="mx-auto mt-4 max-w-md text-white/70" data-id="element-1027" data-mp="1jtc30nypa60b">It may have moved, or the link may be incorrect.</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-1028" data-mp="1nue0p0cyya06">
          <Button to="/" size="lg" data-id="element-1029" data-mp="1susaony4ru0u">
            Return home
          </Button>
          <Button to="/jobs" size="lg" variant="outlineLight" data-id="element-1030" data-mp="1sspajb39kkie">
            Browse opportunities
          </Button>
        </div>
      </div>
    </section>;
}